import React from "react";
import ReactDOM from "react-dom/client";
import Products from '../components/Products.jsx';
import './frontend.css';

document.querySelectorAll(".wp-block-bigsave-product-catalogue").forEach((div) => {
  ReactDOM.createRoot(div).render(<Products/>);
});